import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  FaUserMd,
  FaFlask,
  FaSchool,
  FaMicroscope,
  FaUserFriends,
} from "react-icons/fa";
import { GiMeditation } from 'react-icons/gi';

const items = [
  {
    icon: <FaUserMd className="icon" style={{ color: "#517889" }} />,
    title: "Doctor's Academic Background",
    description: "MBBS + MS / MD / DNB Qualified Experts, Trained from Tier-1 Medical Institutes",
  },
  {
    icon: <FaUserMd className="icon" style={{ color: "#007BFF" }} />,
    title: "Avg. Experience",
    description: "14+ years of average clinical maternity care experience",
  },
  {
    icon: <GiMeditation className="icon" style={{ color: "#b39ddb" }} />,
    title: "Diet, Yoga, & Lactation ",
    description: "Certified Experts with 14+ Years of Experience in Maternity Domain",
  },
  {
    icon: <FaFlask className="icon" style={{ color: "#4dd0e1" }} />,
    title: "Lab Expertise",
    description: "Backed by top NABL-Certified labs with 13+ years of diagnostic excellence",
  },
  {
    icon: <FaMicroscope className="icon" style={{ color: "#5c6bc0" }} />,
    title: "Sonography Specialization",
    description: "Backed by top fetal imaging centers with 15+ years of experience",
  },
  {
    icon: <FaUserFriends className="icon" style={{ color: "#feb1b1" }} />,
    title: "Doctor Panel Strength",
    description: "42+ handpicked doctors across maternity care domains",
  },
]

const Confident = () => {
  return (
    <>
      <div className="bg-light py-5">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-12">
              <h2 className="hero-title text-center">
                {" "}
                What makes us so confident?
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="vertical-trigger col-md-6">
              <div>
                <div>
                  <div className="cards">
                  We are the first in the market to provide a comprehensive 9-month pregnancy
                   (antenatal) care package for moms-to-be by integrating new technology to create an 
                   effective tech-driven pregnancy management model.

                  </div>
                  <div className="cards">
                    Our process is not only smooth but the best across the
                    healthcare industry. From day one until the day your baby is
                    born, your health remains our top priority.
                  </div>
                  <div className="cards">
                    No location limitations, as we specifically curate
                    parameters and set processes to deliver a standardized
                    experience across locations.
                  </div>
                  <div className="cards">
                  We are affordable. We offer complete transparency in care and value for money.
                  .{" "}
                  </div>
                  <div className="cards">
                  All-in-one, complete package-based model to avoid delays and confusion. 
                  Join anytime during your pregnancy.
                  </div>
                  <div className="cards">
                  Exclusive dashboard access of our innovative model to evaluate your 
                  journey every step of the way at your finfertips | 24X7 emergency care.
                  </div>
                  <div className="cards">
                  We specially train our doctors to ensure 
                  every parent has the same amazing experience.
                  </div>
                </div>

                <h3 className="second-title">
                  Sound too good to be true? That’s exactly what we aim for!
                </h3>
                <p className="bold-font paracard burgandi">
                  Pregnancy is a crucial step in your journey to parenthood, and
                  we want to ensure that every aspect is covered.
                </p>
              </div>
            </div>
            <div className="horizontal-trigger  col-md-6 order-mobile">
              {/* <img src="/heroimg1.png">
                </img> */}

              <img
                src="/section2.gif"
                style={{
                  objectFit: "cover",
                  objectPosition: "50% 50%",
                  width: "100%",
                  position: "sticky",
                  top: "120px",
                  maxWidth: "500px",
                  margin: "auto",
                }}
                fetchpriority="high"
              ></img>
            </div>
          </div>
        </div>
        <div className="expertise-container">
          <div className="expertise-wrapper">
            <h2 className="hero-title text-center">Meet Myprega’s Medical Team—Experts Who Truly Capable</h2>
    
            <div className="expertise-grid">
              {items.map((item, index) => (
                <div key={index} className="expertise-card">
                  <div className="icon-wrapper">{item.icon}</div>
                  <h3 className="card-title">{item.title}</h3>
                  <p className="card-description">{item.description}</p>
                </div>
              ))}
            </div>
    
            <div className="bottom-section">
              <p className="bottom-text">
                Your pregnancy is in the skilled hands of highly qualified medical professionals
                handpicked for their expertise and empathy to deliver convenient, never seen, and
                seamless pregnancy experience in India
              </p>
               <a href="/Doctor-profile">
                 <button className="cta-button">Meet Your Partners</button>
               </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export default Confident;
